import { withInstall } from '@bigin/utils'
import Switch from './src/switch.vue'

export const BSwitch = withInstall(Switch)
export default BSwitch

export * from './src/switch'
